module.exports = __webpack_public_path__ + "static/Unisel2-026a667882c82b574fb49cec328a4424.jpg";